import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchEmployersLookupValues(params, config) {
  return axiosRequest('post', serviceUrls.ACCOUNTS_FETCH_EMPLOYERS_LOOKUP_VALUES, params, config);
}

export function fetchClientLookupValues(params, config) {
  return axiosRequest('post', serviceUrls.ACCOUNTS_FETCH_CLIENT_LOOKUP_VALUES, params, config);
}

export function getNewEmployerForm(employerId) {
  return axiosRequest('get', serviceUrls.ACCOUNTS_GET_NEW_EMPLOYER_FORM, { employerId });
}

export function createEmployer(params, config) {
  return axiosRequest('post', serviceUrls.ACCOUNTS_CREATE_EMPLOYER, params, config);
}

export function QuestionnaireProfileList(params, config) {
  return axiosRequest('post', serviceUrls.QUESTIONNAIRE_PROFILE_LIST, params, config);
}
export function QuestionnaireProfileDetails(params, config) {
  return axiosRequest('get', serviceUrls.QUESTIONNAIRE_PROFILE_DETAILS, params, config);
}
export function QuestionnaireProfileDelete(params, config) {
  return axiosRequest('post', serviceUrls.QUESTIONNAIRE_PROFILE_DELETE, params, config);
}
export function upsertRelatedRecord(request) {
  return axiosRequest('post', serviceUrls.QUESTIONNAIRE_TABLE_UPSERT, request, { timeout: 180000 });
}
